<template>
  <div class="Header">
    <div :class="{'area':true,'showBg':showBg}">
      <div class="item item1" @click="toPage('/home')">
        <img class="logo" src="@/assets/logo.png" alt />
        <span class="title">货吉达</span>
      </div>
      <div class="item item2"></div>
      <ul class="item item3">
        <li
          v-for="(item,index) in menuList"
          :key="index"
          :class="{
            'menu-active': isMenuActive(item),
            'has-children': item.children && item.children.length
          }"
          @click="handleMenuClick(item)"
        >
          <span class="menu-label">{{ item.name }}</span>
          <ul
            v-if="item.children && item.children.length"
            class="sub-menu"
          >
            <li
              v-for="(child,childIndex) in item.children"
              :key="childIndex"
              :class="{ 'sub-active': isSubMenuActive(child) }"
              @click.stop="handleSubMenuClick(child)"
            >{{ child.name }}</li>
          </ul>
        </li>
        <!-- app下载单独处理事件 -->
        <li @mouseenter="(e)=>mouseEvt(e,'enter')" @mouseleave="(e)=>mouseEvt(e,'leave')">
          <span class="menu-label">APP下载</span>
        </li>
      </ul>
      <div class="item item4" @click="drawer = true">
        <img class="img" src="@/assets/list.png" alt />
      </div>
    </div>
    <div class="backBtn" v-if="routeName == '/newsDetail'" @click="toPage('/news')">
      <img :src="backBtnUrl" alt />
    </div>
    <div v-if="showDownload" class="appDown" ref="appDown">
      <img src="@/assets/index/bottom/app.png" alt />
    </div>
    <el-drawer
      title="中昊供应链"
      size="50%"
      :visible.sync="drawer"
      direction="rtl"
      :append-to-body="true"
    >
      <ul class="list">
        <li
          v-for="(item,index) in menuList"
          :key="item.key || index"
          class="drawer-item"
        >
          <div class="drawer-parent" @click="handleDrawerMenuClick(item)">{{ item.name }}</div>
          <ul
            v-if="item.children && item.children.length"
            class="drawer-children"
            v-show="isDrawerGroupOpen(item)"
          >
            <li
              v-for="(child,childIndex) in item.children"
              :key="child.key || (item.key || index) + '-' + childIndex"
              class="sub-item"
              @click="handleSubMenuClick(child)"
            >{{ child.name }}</li>
          </ul>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      showDownload: false,
      drawer: false,
      showBg: false,
      activeMenuKey: "",
      drawerGroupOpen: {},
      backBtnUrl: require("@/assets/header/back-light.png"),
      menuList: [
        { key: "home", name: "首页", path: "/home" },
        { key: "news", name: "行业动态", path: "/news" },
        {
          key: "logistics",
          name: "国际物流",
          path: "/international",
          children: [
            { key: "logistics-road", name: "国际公路运输", path: "/international#highway" },
            { key: "logistics-sea", name: "国际船舶运输", path: "/international#ocean" },
            { key: "logistics-air", name: "国际航空运输", path: "/international#aviation" }
          ]
        },
        {
          key: "freight",
          name: "货运信息",
          children: [
            { key: "freight-source", name: "货源信息", path: "/source" },
            { key: "freight-transport", name: "运力信息", path: "/transport" }
          ]
        },
        { key: "aboutus", name: "关于我们", path: "/aboutus" },
        { key: "statistics", name: "业务统计", path: "/statistics" }
      ]
    };
  },
  mounted() {
    this.initial();
    this.syncActiveMenuByRoute();
  },
  computed: {
    routeName() {
      return this.$route.path;
    },
    routeHash() {
      return this.$route.hash;
    }
  },
  watch: {
    routeName() {
      this.syncActiveMenuByRoute();
    },
    routeHash() {
      this.syncActiveMenuByRoute();
    }
  },
  methods: {
    async initial() {
      let _this = this;
      window.addEventListener("scroll", function() {
        // 滚动事件触发后执行的代码
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        _this.showBg = scrollTop > 5;
        // console.log('_this.showBg',_this.showBg);
        
        _this.backBtnUrl = !_this.showBg
          ? require("@/assets/header/back-light.png")
          : require("@/assets/header/back-dark.png");
        let app = document.getElementById("app");
        app.style.setProperty("--fontColor", scrollTop > 5 ? "#333" : "#fff");
      });
    },
    mouseEvt(e, type) {
      if (type == "enter") {
        this.showDownload = true;
        let traget = e.target;
        let rect = traget.getBoundingClientRect();
        this.$nextTick(() => {
          this.$refs.appDown.style.left = rect.left - 40 + "px";
          this.$refs.appDown.style.top = rect.bottom + 20 + "px";
        });
      } else {
        this.showDownload = false;
      }
    },
    isMenuActive(item) {
      if (item.key === this.activeMenuKey) {
        return true;
      }
      return (item.children || []).some(child => child.key === this.activeMenuKey);
    },
    isSubMenuActive(child) {
      return child.key === this.activeMenuKey;
    },
    syncActiveMenuByRoute() {
      const routeMenuMap = {
        "/": "home",
        "/home": "home",
        "/news": "news",
        "/newsDetail": "news",
        "/international": "logistics",
        "/source": "freight-source",
        "/transport": "freight-transport",
        "/aboutus": "aboutus",
        "/statistics": "statistics"
      };

      if (this.routeName === "/international") {
        const hashMap = {
          "#highway": "logistics-road",
          "#ocean": "logistics-sea",
          "#aviation": "logistics-air"
        };
        this.activeMenuKey = hashMap[this.routeHash] || "logistics";
        return;
      }

      this.activeMenuKey = routeMenuMap[this.routeName] || "";
    },
    handleMenuClick(item) {
      if (item.children && item.children.length) {
        if (item.path) {
          this.activeMenuKey = item.key;
          this.toPage(item.path);
        }
        return;
      }
      this.activeMenuKey = item.key;
      this.toPage(item.path);
    },
    handleDrawerMenuClick(item) {
      if (item.children && item.children.length) {
        this.$set(
          this.drawerGroupOpen,
          item.key,
          !this.drawerGroupOpen[item.key]
        );
        return;
      }
      this.handleMenuClick(item);
    },
    isDrawerGroupOpen(item) {
      if (!item.children || !item.children.length) {
        return false;
      }
      return !!this.drawerGroupOpen[item.key];
    },
    handleSubMenuClick(child) {
      this.activeMenuKey = child.key;
      this.toPage(child.path);
    },
    toPage(path) {
      this.$router.push(path);
      this.drawer = false;
      this.drawerGroupOpen = {};
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.Header {
  position: relative;
  width: 100%;
  height: $headerHeight;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  z-index: 999;
  .backBtn {
    position: absolute;
    left: 5px;
    top: 20px;
    img {
      width: 30px;
      cursor: pointer;
    }
  }
  .appDown {
    position: fixed;
    left: 0;
    top: 0;
    img {
      width: 150px;
    }
  }
  .area {
    margin: 0 auto;
    width: 80%;
    height: 100%;
    transition: all 0.5s;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #fff;
  }
  .showBg {
    width: 100%;
    height: 90%;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);
    color: $fontColor;
    .title {
      transition: all 0.3s;
      margin-left: 15px;
    }
  }
  .item {
    display: flex;
    align-items: center;
  }
  .item1 {
    font-size: 24px;
    cursor: pointer;
    .logo{
      width: 60px;
    }
    .title{
      margin-left: 15px;
    }
  }

  .item3 {
    list-style: none;
    font-size: 14px;
    font-weight: bold;

    li {
      margin: 0 20px;
      cursor: pointer;
      position: relative;
      transition: all 0.3s;

      &:hover {
        color: $fontHoverColor;
      }
      &:hover > .menu-label::after {
        width: 100%;
        transform: translateX(-50%);
        opacity: 1;
      }
    }
    .menu-label {
      display: inline-block;
      padding: 8px 0;
      position: relative;

      &::after {
        width: 0%;
        content: "";
        height: 4px;
        background-color: var(--fontColor);
        position: absolute;
        bottom: -10px;
        left: 50%;
        right: auto;
        opacity: 0;
        transition: all 0.3s;
      }
    }
    .has-children {
      padding-bottom: 12px;
      margin-bottom: -12px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        height: 18px;
      }
      &:hover {
        .sub-menu {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
          pointer-events: auto;
        }
      }
    }
    .sub-menu {
      position: absolute;
      left: 60%;
      top: calc(100% - 10px);
      transform: translateX(-50%) translateY(8px);
      min-width: 150px;
      margin: 0;
      padding: 8px 0;
      list-style: none;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: all 0.2s;
      z-index: 10;

      li {
        margin: 0;
        padding: 10px 16px;
        color: #333;
        white-space: nowrap;

        &:hover {
          color: $fontHoverColor;
          background: rgba(15, 131, 235, 0.08);
        }
        &:hover::after,
        &::after {
          display: none;
        }
      }
      .sub-active {
        color: $fontHoverColor;
        background: rgba(15, 131, 235, 0.08);

        &::after {
          display: none;
        }
      }
    }
    .menu-active {
      > .menu-label::after {
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 1;
      }
      &:hover {
        color: $fontHoverColor;
      }
      &:hover > .menu-label::after {
        width: 100%;
        transform: translateX(-50%);
        opacity: 1;
      }
    }
  }
  .item4 {
    display: none;
    .img {
      width: 25px;
    }
  }

  @media screen and (max-width: 767px) {
    .item3 {
      display: none;
    }
    .item4 {
      display: block;
    }
  }
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;

  .drawer-item {
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .drawer-parent {
    font-size: 15px;
    font-weight: 700;
    // color: #333;
  }

  .drawer-children {
    list-style: none;
    padding: 8px 0 0;
    margin: 0;
  }

  .sub-item {
    padding-left: 20px;
    color: #666;
    font-size: 13px;
  }
}
</style>
